import { Icon } from '@adobe/react-spectrum';

const TargetIcon = props => {
  return (
    <Icon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M10 11.5C10.8284 11.5 11.5 10.8284 11.5 10C11.5 9.17157 10.8284 8.5 10 8.5C9.17157 8.5 8.5 9.17157 8.5 10C8.5 10.8284 9.17157 11.5 10 11.5Z"
          fill="#222222"
        />
        <path
          d="M10 18.75C5.17529 18.75 1.25 14.8252 1.25 10C1.25 5.1748 5.17529 1.25 10 1.25C14.8247 1.25 18.75 5.1748 18.75 10C18.75 14.8252 14.8247 18.75 10 18.75ZM10 2.75C6.00244 2.75 2.75 6.00195 2.75 10C2.75 13.998 6.00244 17.25 10 17.25C13.9976 17.25 17.25 13.998 17.25 10C17.25 6.00195 13.9976 2.75 10 2.75Z"
          fill="#292929"
        />
        <path
          d="M10 15C7.24316 15 5 12.7568 5 10C5 7.24316 7.24316 5 10 5C12.7568 5 15 7.24316 15 10C15 12.7568 12.7568 15 10 15ZM10 6.5C8.07031 6.5 6.5 8.07031 6.5 10C6.5 11.9297 8.07031 13.5 10 13.5C11.9297 13.5 13.5 11.9297 13.5 10C13.5 8.07031 11.9297 6.5 10 6.5Z"
          fill="#292929"
        />
      </svg>
    </Icon>
  );
};

export default TargetIcon;
